import type { StateCreator } from 'zustand';

import type { UserSlice } from './types';

export type { UserSlice } from './types';

export const userInitialState = {
  credits: 0,
  isCreditsLoading: false,
  areCreditsAvailable: null as boolean | null,
  availableCredits: null as number | null,
};

export const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (
  set
) => ({
  ...userInitialState,

  setCredits: (credits) => set({ credits }),
  setIsCreditsLoading: (isCreditsLoading) => set({ isCreditsLoading }),
  setAreCreditsAvailable: (areCreditsAvailable) => set({ areCreditsAvailable }),
});
